import { render, staticRenderFns } from "./TaskDefinitionEdit.vue?vue&type=template&id=21ef277b&"
import script from "./TaskDefinitionEdit.vue?vue&type=script&lang=js&"
export * from "./TaskDefinitionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports